import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  Stack,
  Divider,
} from "@mui/material";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import SpeedIcon from "@mui/icons-material/Speed";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import VerifiedIcon from "@mui/icons-material/Verified";
import HubIcon from "@mui/icons-material/Hub";

export default function RPA() {
  return (
    <Box sx={{ backgroundColor: "#020617", color: "#e5e7eb" }}>
      {/* ================= HERO ================= */}
      <Box sx={{ py: 12 }}>
        <Container>
          <Typography
            variant="h3"
            align="center"
            fontWeight={600}
            gutterBottom
          >
            Robotic Process Automation
          </Typography>

          <Typography
            align="center"
            sx={{ maxWidth: 900, mx: "auto", opacity: 0.9 }}
          >
            We help organizations automate repetitive, rule-based business
            processes using intelligent RPA solutions to improve efficiency,
            accuracy, and scalability.
          </Typography>

          {/* Tabs */}
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            mt={6}
            flexWrap="wrap"
          >
            <Button sx={tab}>Process Automation</Button>
            <Button sx={tab}>Operational Efficiency</Button>
            <Button sx={tab}>Cost Optimization</Button>
            <Button sx={tab}>Enterprise RPA</Button>
          </Stack>

          <Divider sx={{ mt: 3, borderColor: "#1e293b" }} />
        </Container>
      </Box>

      {/* ================= CORE SECTION ================= */}
      <Container sx={{ py: 10 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>
              Intelligent Automation for Modern Enterprises
            </Typography>

            <Typography sx={{ mb: 3, opacity: 0.9 }}>
              Our RPA solutions automate repetitive and time-consuming tasks,
              enabling organizations to reduce manual effort, minimize errors,
              and increase operational efficiency.
            </Typography>

            <Typography sx={{ opacity: 0.85 }}>
              By integrating RPA with existing systems, we help businesses
              streamline workflows without disrupting current operations.
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80"
                alt="RPA Automation"

              sx={{
                width: "100%",
                borderRadius: 3,
                boxShadow: "0 20px 40px rgba(0,0,0,0.45)",
              }}
            />
          </Grid>
        </Grid>
      </Container>

      {/* ================= WHY CHOOSE US ================= */}
      <Box sx={{ backgroundColor: "#020617", py: 12 }}>
        <Container>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            fontWeight={600}
          >
            Why Choose NerdsHub for RPA?
          </Typography>

          <Grid container spacing={8} mt={4}>
            {/* Left Image */}
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src="https://images.unsplash.com/photo-1555949963-aa79dcee981c"
                alt="Business Automation"
                sx={{ width: "100%", borderRadius: 3 }}
              />
            </Grid>

            {/* Right Content */}
            <Grid item xs={12} md={6}>
              <Feature
                icon={<PrecisionManufacturingIcon />}
                title="End-to-End Automation"
                desc="We automate rule-based and repetitive tasks across finance, operations, HR, and customer service."
              />

              <Feature
                icon={<SpeedIcon />}
                title="Faster Process Execution"
                desc="Bots operate 24/7, significantly reducing turnaround times and improving service delivery."
              />

              <Feature
                icon={<AutoAwesomeIcon />}
                title="Business Innovation"
                desc="By eliminating manual work, teams can focus on strategic, high-impact initiatives."
              />
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ================= GOVERNANCE & SUPPORT ================= */}
      <Container sx={{ py: 12 }}>
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=80"
alt="RPA Governance and Compliance"


              sx={{ width: "100%", borderRadius: 3 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Feature
              icon={<HubIcon />}
              title="Seamless System Integration"
              desc="RPA bots integrate smoothly with existing enterprise applications and legacy systems."
            />

            <Feature
              icon={<VerifiedIcon />}
              title="Governance & Compliance"
              desc="Built with security, auditability, and compliance best practices to meet enterprise standards."
            />

            <Feature
              icon={<SupportAgentIcon />}
              title="Ongoing Support & Optimization"
              desc="From assessment to deployment and continuous optimization, we support you at every stage."
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

/* ================= REUSABLE FEATURE ================= */

function Feature({ icon, title, desc }) {
  return (
    <Box sx={{ display: "flex", mb: 5 }}>
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          backgroundColor: "#ec4899",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 3,
          color: "#fff",
        }}
      >
        {icon}
      </Box>

      <Box>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography sx={{ opacity: 0.85 }}>{desc}</Typography>
      </Box>
    </Box>
  );
}

/* ================= STYLES ================= */

const tab = {
  color: "#9ca3af",
  textTransform: "none",
};
